<template>
  <nav class="navbar is-fixed-top">
    <div class="navbar-brand">
      <router-link class="navbar-item" to="/" exact>
        <span class="app-title">Toolindo</span>
      </router-link>
      <router-link class="navbar-item menu-link" v-for="(item, idx) in listmenu"
        :key="`menu-${idx}`" :to="item.link" exact>
        {{ item.title }}
      </router-link>
    </div>

    <div class="navbar-menu">
      <div class="navbar-end">
        <b-dropdown v-model="navigation" position="is-bottom-left" aria-role="menu">
          <a class="navbar-item menu-drop" slot="trigger" role="button">
            <span>Logged as <b>{{ username }}</b></span>
            <b-icon icon="menu-down"></b-icon>
          </a>
          <b-dropdown-item value="home" aria-role="menuitem">
            <b-icon icon="home"></b-icon><span class="menu-text">Home</span>
          </b-dropdown-item>
          <b-dropdown-item value="sales" aria-role="menuitem">
            <b-icon icon="cash-100"></b-icon><span class="menu-text">Sales</span>
          </b-dropdown-item>
          <b-dropdown-item value="stock" aria-role="menuitem">
            <b-icon icon="package-variant-closed"></b-icon><span class="menu-text">Stock</span>
          </b-dropdown-item>
          <hr class="dropdown-divider" aria-role="menuitem">
          <b-dropdown-item value="forget">
            <b-icon icon="lock-reset"></b-icon><span class="menu-text">Change Password</span>
          </b-dropdown-item>
          <b-dropdown-item value="logout" aria-role="menuitem" @click="logoutSubmit">
            <b-icon icon="logout"></b-icon><span class="menu-text">Logout</span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      navigation: 'home',
      listmenu: [
        { title: 'Sales', link: '/sales' },
        { title: 'Stock', link: '/stock' },
      ],
    };
  },
  methods: {
    ...mapActions([
      'logout',
    ]),
    logoutSubmit() {
      this.logout().then((res) => {
        if (res) {
          this.$router.push('/login');
        }
      }, (e) => {
        this.$dialog.alert(e);
      });
    },
  },
  computed: {
    username() {
      const token = this.$store.state.accessToken.split('.');
      return atob(token[1]);
    },
  },
  watch: {
    navigation(newVal) {
      if (newVal !== 'logout') {
        this.$router.push({ name: newVal });
      }
    },
    '$route.name': {
      handler(name) {
        this.navigation = name;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
nav.navbar {
  background-color: #042C71;
  .app-title {
    color: #F8D605;
    font-weight: 600;
  }
  .menu-link {
    color: #FFFFFF;
    &:hover {
      background: #FFFFFF;
      color: #042C71;
    }
    &.router-link-active {
      border-bottom: 4px solid #F8D605;
      color: #F8D605;
    }
  }
  .menu-drop {
    color: #FFFFFF;
    &:hover {
      color: #042C71;
    }
  }
  .menu-text {
    margin-left: 1rem;
    line-height: 1rem;
  }
}
</style>
